import { API } from "@/main";

const state = {
  workspace: {
    label: sessionStorage.getItem("workspace_name") || "",
    uuid: sessionStorage.getItem("workspace_uuid") || "",
    id: sessionStorage.getItem("workspace_id") || "",
    geo_json: sessionStorage.getItem("workspace_geo_json") || "",
    engineering_rules_id: sessionStorage.getItem("workspace_rules_id")
  },
  allWorkspaces: []
};

const getters = {
  workspace: state => state.workspace,
  allWorkspaces: state => state.allWorkspaces
};

const mutations = {
  setUserWorkspace(state, workspace) {
    if (workspace) {
      let workspaceLabel = workspace.wp_label;
      let workspaceUUID = workspace.wp_uuid;
      let workspaceID = workspace.wp_id;
      let workspaceRulesId = workspace.engineering_rule ? workspace.engineering_rule.id : workspace.wp_engineering_rule_id;
      // Change MultiPolygon to Polygon

      if (workspace.wp_geo_json) {
        let workspaceGeoJson = JSON.parse(workspace.wp_geo_json);

        workspaceGeoJson.coordinates[0] = workspaceGeoJson.coordinates[0][0];
        workspaceGeoJson.type = "Polygon";
        workspaceGeoJson = JSON.stringify(workspaceGeoJson);

        state.workspace.geo_json = workspaceGeoJson;

        sessionStorage.setItem("workspace_geo_json", workspaceGeoJson);
      }

      state.workspace.label = workspaceLabel;
      state.workspace.uuid = workspaceUUID;
      state.workspace.id = workspaceID;

      sessionStorage.setItem("workspace_name", workspaceLabel);
      sessionStorage.setItem("workspace_uuid", workspaceUUID);
      sessionStorage.setItem("workspace_id", workspaceID);
      sessionStorage.setItem("workspace_rules_id", workspaceRulesId);
    }
  },

  clearUserWorkspace(state) {
    state.workspace.label = "";
    state.workspace.uuid = "";
    state.workspace.geo_json = "";

    sessionStorage.setItem("workspace_name", "");
    sessionStorage.setItem("workspace_uuid", "");
    sessionStorage.setItem("workspace_geo_json", "");
  },

  setWorkspaceGeoJson(state, workspace) {
    let workspaceGeoJson = JSON.stringify(workspace);
    state.workspace.geo_json = workspaceGeoJson;
    sessionStorage.setItem("workspace_geo_json", workspaceGeoJson);
  },

 setAllWorkspaces(state, result) {
    state.allWorkspaces = result;
  }
};
const actions = {

  fetchWorkspaces({ commit }, queryParams = null) {
    return new Promise((resolve, reject) => {
      API.workspace.getWorkspaces(
        queryParams,
        "users,companies",
        result => {
          resolve(result.data);
          commit("setAllWorkspaces", result.data.data)
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchAllWorkspaces: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.workspace.getAll(
        data.includes,
        data.fields,
        result => {
          resolve(result.data.data);
          commit("setAllWorkspaces", result.data.data)
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchAllWorkspacesPaginated: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.workspace.getAllPaginated(
        data.queryParams ? data.queryParams : null,
        data.includes,
        data.fields,
        result => {
          resolve(result.data);
          commit("setAllWorkspaces", result.data.data)
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchWorkspaceByUUID: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.workspace.getByUUID(
        data.uuid,
        data.includes,
        data.fields,
        result => {
          resolve(result.data.data[0]);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchWorkspacesContainsObject({ commit }, { objectType, objectUuid, params }) {
    return new Promise((resolve, reject) => {
      API.workspace.getWorkspacesContainsObject(
        objectType,
        objectUuid,
        params,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  downloadAllWorkspaces({ commit }) {
    return new Promise((resolve, reject) => {
      API.workspace.downloadAll(
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },
  

  fetchWorkspacesLayersObject({ commit }, { queryParams, layer, workspaceUuid, geom = null}) {
    return new Promise((resolve, reject) => {
      API.workspace.getWorkspacesLayersObject(
        queryParams,
        layer,
        workspaceUuid,
        geom,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteWorkspacesLayersObject({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.workspace.deleteLayerObjects(
        data.layer,
        data.data,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  CREATE_WORKSPACE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.workspace.create(
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  EDIT_WORKSPACE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.workspace.edit(
        data.id,
        data.data,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  DELETE_WORKSPACE: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      API.workspace.delete(
        id,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchNetworkOfWorkspacesTree: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.workspace.getNetworkOfWorkspacesTree(
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  setCurrentWorkspace: ({ commit }, workspace) => {
    commit("setUserWorkspace", workspace);
  },

  setWorkspaceGeoJson: ({ commit }, workspaceGeoJson) => {
    commit("setWorkspaceGeoJson", workspaceGeoJson);
  },

  clearWorkspace({ commit }) {
    commit("clearUserWorkspace");
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/workspace.js